<app-generic-selector
  [selected]="source"
  [options]="selectorOptions"
  [mode]="mode"
  (selection)="onSelection($event)">
</app-generic-selector>
